import React, { useEffect, useState } from 'react';
import s from './OrderDetails.module.scss';
import ProfileMenuHeader from 'modules/app/components/ProfileMenu/ProfileMenuHeader';
import { useNavigate, useParams } from 'react-router-dom';
import Estimated from './Estimated';
import Status from './Status';
import Address from './Address';
import Product from './Product';
import Button from 'components/shared/Button';
import useGetOrderById from 'sdk/hooks/shop/useGetOrderById';
import useGetTransactionById from 'sdk/hooks/shop/useGetTransactionById';
import useGetProductById from 'sdk/hooks/shop/useGetProductById';
import useGetOrders from './api';

const OrderDetails = () => {
  const { id, productId } = useParams();
  const navigate = useNavigate();

  const { data: transactionId } = useGetOrderById(id);
  const { data: transaction } = useGetTransactionById(transactionId?.transaction_id);
  const { data: product } = useGetProductById(productId);
  const {
    data: orders,
    refetch,
    isLoading,
  } = useGetOrders(transactionId?.transaction_id, productId);
  const [orderStatusHistory, setOrderStatusHistory] = useState([]);

  const handleClose = () => {
    navigate("/");
  };

  const fetchOrderHistory = async orderIds => {
    try {
      const req = await fetch(
        'https://gibnkggiuxphkienkxwf.supabase.co/functions/v1/get-oto-order-history',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdpYm5rZ2dpdXhwaGtpZW5reHdmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzA3OTI0OTEsImV4cCI6MjA0NjM2ODQ5MX0.jzHj8vjuo7KuX4nHi-_tq051mp9quUNKMP0wN8Makj4`, // Замените YOUR_ACCESS_TOKEN на ваш токен
          },
          body: JSON.stringify({ id: orderIds }),
        },
      );

      const data = await req.json();

      setOrderStatusHistory(data?.items?.[0]?.history);
    } catch (error) {
      console.error('Error fetching order history:', error);
    }
  };

  useEffect(() => {
    if (transaction) {
      refetch();
      //@ts-ignore
      fetchOrderHistory([String(orders?.[0]?.order_id)]);
    }
  }, [transaction, orders]);

  return (
    <div className={s.order}>
      <ProfileMenuHeader text={`Order №${id}`} onClose={handleClose} />
      <div className={s.order__items}>
        <Estimated />
        {isLoading ? <>Loading status history...</> : <></>}
        {orderStatusHistory?.map(item => {
          return (
            <Status
              //@ts-ignore
              date={item?.date}
              //@ts-ignore
              status={item?.status}
            />
          );
        })}
      </div>
      <div className={s.order__items} style={{ paddingTop: 24 }}>
        <Address address={transaction?.user_shippings} />
        <Product product={product} />
        <Button darkGreen onClick={() => navigate(`/add-product-review/${productId}`)}>
          Leave a review
        </Button>
      </div>
    </div>
  );
};

export default OrderDetails;
